import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { isCapacitorNative } from '@utils/capacitor-utils';
import { PluginListenerHandle } from '@capacitor/core';

/** Hook to listen for app state changes (foreground/background)
 * and execute a callback when the app becomes active (foreground).
 * AVAILABLE ONLY ON NATIVE MOBILE
 * */
export const useAppStateListener = (onAppBecomeActive: () => void) => {
  useEffect(() => {
    if (!isCapacitorNative()) return;

    let listenerHandle: PluginListenerHandle | null = null;

    const setupListener = async () => {
      try {
        listenerHandle = await App.addListener('appStateChange', (state) => {
          if (state.isActive) {
            console.info('App has become active again.');
            onAppBecomeActive();
          }
        });
      } catch (error) {
        console.error('Error setting up listener:', error);
      }
    };

    setupListener();

    return () => {
      listenerHandle?.remove(); // cleaning up the listener
    };
  }, [onAppBecomeActive]);
};
